import { ButtonProps } from "@chakra-ui/react";
import { SkuBrandOrderingPlatformFilter } from "__generated__/gql/graphql";
import ExportButton from "components/Shared/ExportButton";
import { asyncVoid } from "utils/asyncVoidHandler";
import { useCurrentBrandId } from "utils/currentUserHooks";
import { useFetchExport } from "utils/fetchExport";

export type Props = Omit<ButtonProps, "filter"> & {
  filter?: SkuBrandOrderingPlatformFilter | null;
};

export default function ExportCustomerProductPresenceButton({
  filter,
  isDisabled,
  ...rest
}: Props) {
  const brandId = useCurrentBrandId();

  const [fetchExport, { isLoading }] = useFetchExport();

  const handleClick = () => {
    asyncVoid(fetchExport("customer_product_presence", { brandId, filter }));
  };

  return (
    <ExportButton
      onClick={handleClick}
      isDisabled={isDisabled || !brandId}
      isLoading={isLoading}
      variant="outline"
      mr={4}
      alignSelf="center"
      {...rest}
    />
  );
}
